import { Directive, Input, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[upCopyButton]'
})
export class UtilsCopyButtonDirective {
  @Input() text: string;
  @Output() cbOnSuccess: EventEmitter<any> = new EventEmitter<any>();

  @HostListener('click', ['$event'])
  public onClick(): void {
    event.preventDefault();
    if (!this.text) {
      return;
    }

    const range = document.createRange();
    range.selectNodeContents(document.body);
    document.getSelection().addRange(range);

    const listener = (e: ClipboardEvent) => {
      const clipboard = e.clipboardData || window['clipboardData'];
      clipboard.setData('text', this.text.toString());
      e.preventDefault();
      this.cbOnSuccess.emit({ isSuccess: true, content: this.text });
    };

    document.addEventListener('copy', listener, false);
    document.execCommand('copy');
    document.removeEventListener('copy', listener, false);

    document.getSelection().removeAllRanges();
  }
}
